import { Outlet, Navigate } from 'react-router-dom';
import { checkAuthen } from '~/helpers/authen';

const PrivateRoutes = () => {
    return checkAuthen() ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
